import React, { Component } from 'react';
export default class About extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <React.Fragment>
      {/*generated code*/}
      <section id="about">
        <div className="row">
          <div className="three columns">
            <img className="profile-pic" src="images/profilepic1.jpg" alt="" />
          </div>
          <div className="nine columns main-col">
            <h2>Sobre Mim</h2>
            <p>
              {resumeData.aboutme}
            </p>
            <div className="row">
              <div className="columns contact-details">
                <h2>Detalhes para Contato</h2>
                <p className="address">
                  <span>{resumeData.name}</span><br />
                  <span>{resumeData.address}<br />
                    {resumeData.neighborhood}, {resumeData.city} - {resumeData.state}, {resumeData.initialsCountry}
                  </span><br />
                  <span>{resumeData.tel}</span><br />
                  <span>{resumeData.mail}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> 
      </React.Fragment>
    );
  }
}